module.exports = __webpack_public_path__ + "ff745532336e2550192a38605a0971c5.jpg";